export * from './enquiry/enquiry.component';
export * from './admission/admission.component';
export * from './pgenquiry/pgenquiry.component';
export * from './sms/sms.component';